// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-beint-tsx": () => import("./../src/pages/beint.tsx" /* webpackChunkName: "component---src-pages-beint-tsx" */),
  "component---src-pages-framundan-tsx": () => import("./../src/pages/framundan.tsx" /* webpackChunkName: "component---src-pages-framundan-tsx" */),
  "component---src-pages-index-tsx": () => import("./../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

